import React, {useState, createContext} from 'react'

export const ConditionContext = createContext()

export const ConditionProvider = (props) => {
    const[conditionState, setConditionState] = useState({})
    return (
        <ConditionContext.Provider value={[conditionState,setConditionState]}>
            {props.children}
        </ConditionContext.Provider>
    )
}